"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon20Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCDownIcon20Solid = forwardRef_1.forwardRef('ArrowCDownIcon20Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M17.222 6.403a1.375 1.375 0 0 1 0 1.944l-5.013 5.013a3.125 3.125 0 0 1-4.42 0L2.778 8.347a1.375 1.375 0 1 1 1.945-1.944l5.012 5.012a.375.375 0 0 0 .53 0l5.014-5.012a1.375 1.375 0 0 1 1.944 0Z" })));
});
